import React from "react";
import { Chart } from "react-google-charts";


// export const data = [
//     ["Generation", "Descendants","Descendants"],
//     [0, 1, 1],
//     [1, 33, 33],
//     [2, 269, 269],
//     [3, 2013, 2013],
// ];


interface InputValues {
    data: any
    options: any
}


export function ScatterChart({data, options}: InputValues) {
    return (
        <Chart
            chartType="ScatterChart"
            width="100%"
            height="400px"
            data={data}
            options={options}
            />
        );
        }
